import React from 'react'

import appImg from "../../media/explore/explore-app.png"
import digitalImg from "../../media/explore/explore-digi.png"
import webImg from "../../media/explore/explore-web.png"
import { Link } from 'react-router-dom'

// it is made for navbar to content in all pages

const ExploreMorePopUp = () => {

    let popStyleContainerStyle = {
        // height: "550px",
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%,-50%)",
        zIndex: "9999"
    }

    return (
        <>
            <div className="collapse container-fluid w-75 bg-light shadow-lg" id='explore-pop-up' style={popStyleContainerStyle}>
                <div className="container">
                    <div className='p-2'>
                        <div className="fs-3 fw-bold">
                            Yes ! you find us <span className='text-danger'>right.</span>
                        </div>
                        <div>
                            <span className='fs-4'>
                                So what are looking a <span className='text-danger fw-bold'>Website</span>, <span className='text-danger fw-bold'>Social Media Campains</span>, <span className='text-danger fw-bold'>Local Ranking</span> or a <span className='text-danger fw-bold'>Mobile Application</span>.
                            </span>
                        </div>

                        {/* corousel for explore section */}

                        {/* web development, digital marketing and app development */}

                        <div id="Explore-pop-up-carousel" class="carousel slide">
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#Explore-pop-up-carousel" data-bs-slide-to="0" className="active bg-danger" aria-current="true" aria-label="Slide 1">
                                </button>
                                <button type="button" data-bs-target="#Explore-pop-up-carousel" className='bg-danger' data-bs-slide-to="1" aria-label="Slide 2">
                                </button>
                                <button type="button" data-bs-target="#Explore-pop-up-carousel" className='bg-danger' data-bs-slide-to="2" aria-label="Slide 3">
                                </button>
                            </div>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className='row'>

                                        <div className="col d-flex flex-column align-items-start justify-content-center gap-3">
                                            <h5>
                                                A internet space <span className='text-danger'>for your business</span>
                                                , where success begins online.
                                            </h5>
                                            <div>
                                                <p>Creating a custom solution for a business website can significantly enhance your online presence and provide a platform for growth.</p>
                                                <p>
                                                    By implementing these custom solutions, you can effectively kickstart your online business and provide a seamless experience for your customers.
                                                </p>
                                            </div>
                                            <div>
                                                <h6>Key Features</h6>
                                                <li><span className='fw-bold text-danger'>Eye-catching Design:</span> Use high-quality images and a clean layout.</li>
                                                <li><span className='fw-bold text-danger'>Call to Action (CTA):</span> Encourage visitors to take specificactions such as signing up, purchasing, or learning more.</li>
                                                <li><span className='fw-bold text-danger'>Product/Service Details:</span> Highlight key features and benefits.</li>
                                                <li><span className='fw-bold text-danger'>Customer Testimonials:</span> Build trust with reviews andtestimonials.</li>
                                                <li><span className='fw-bold text-danger'>Contact Form:</span> Make it easy for visitors to reach out for moreinformation</li>
                                            </div>
                                            <div className='cta pt-4 d-flex gap-2'>
                                                <button className='btn btn-primary btn-sm fw-bold' data-bs-toggle="collapse" data-bs-target="#explore-pop-up">Close <i className="fa-solid fa-close"></i></button>
                                                <Link to="/WebDevelopment" className='btn btn-danger btn-sm fw-bold'>Learn More <i className="fa-solid fa-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <img className='img-fluid' src={webImg} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className='row'>
                                        <div className="col d-flex flex-column align-items-start justify-content-center gap-3">
                                            <h5>
                                                A digital marketing solution <span className='text-danger'>for your business</span>, where success begins online.
                                            </h5>
                                            <div>
                                                <p>Crafting a tailored digital marketing strategy can significantly boost your online presence and drive business growth.</p>
                                                <p>
                                                    By utilizing these customized marketing solutions, you can effectively enhance your online visibility and deliver a seamless experience for your target audience.
                                                </p>
                                            </div>
                                            <div>
                                                <h6>Key Features</h6>
                                                <li><span className='fw-bold text-danger'>SEO:</span> Improve search engine rankings and organic traffic.</li>
                                                <li><span className='fw-bold text-danger'>Targeted Advertising:</span> Reach the audience with precise ad targeting.</li>
                                                <li><span className='fw-bold text-danger'>Content Marketing:</span> Engage your audience with relevant content.</li>
                                                <li><span className='fw-bold text-danger'>Social Media Management:</span> Build a strong social media presence.</li>
                                                <li><span className='fw-bold text-danger'>Analytics & Reporting:</span> Track performance and optimize strategies.</li>
                                            </div>
                                            <div className='cta pt-4 d-flex gap-2'>
                                                <button className='btn btn-primary btn-sm fw-bold' data-bs-toggle="collapse" data-bs-target="#explore-pop-up">Close <i className="fa-solid fa-close"></i></button>
                                                <Link to="/DigitalMarketing" className='btn btn-danger btn-sm fw-bold'>Learn More <i className="fa-solid fa-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <img className='img-fluid' src={digitalImg} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className='row'>

                                        <div className="col d-flex flex-column align-items-start justify-content-center gap-3">
                                            <h5>
                                                An app development solution <span className='text-danger'>for your business</span>, where innovation begins.
                                            </h5>
                                            <div>
                                                <p>Developing a custom app can significantly enhance your business operations and provide a unique platform for customer engagement.</p>
                                                <p>
                                                    By leveraging these app development solutions, you can effectively streamline your processes and deliver a seamless experience for your users.
                                                </p>
                                            </div>
                                            <div>
                                                <h6>Key Features</h6>
                                                <li><span className='fw-bold text-danger'>User-Friendly Interface:</span> Design with intuitive navigation layout.</li>
                                                <li><span className='fw-bold text-danger'>Custom Functionality:</span> Tailor features to meet your goals.</li>
                                                <li><span className='fw-bold text-danger'>Cross-Platform Compatibility:</span> Ensure your app works on both iOS and Android.</li>
                                                <li><span className='fw-bold text-danger'>Security:</span> Protect data with advanced security.</li>
                                                <li><span className='fw-bold text-danger'>Analytics:</span> Track user engagement and performance for continuous improvement.</li>
                                            </div>
                                            <div className='cta pt-4 d-flex gap-2'>
                                                <button className='btn btn-primary btn-sm fw-bold' data-bs-toggle="collapse" data-bs-target="#explore-pop-up">Close <i className="fa-solid fa-close"></i></button>
                                                <Link to="/AppDevelopment" className='btn btn-danger btn-sm fw-bold'>Learn More <i className="fa-solid fa-arrow-right"></i></Link>
                                            </div>
                                        </div>

                                        <div className="col">
                                            <img className='img-fluid' src={appImg} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExploreMorePopUp